import Button from "./Button.vue";
import { pluginify } from "./../../util";
export default pluginify(Button);
export { Button };
